'use client';

import { SignUp } from '@clerk/clerk-react';
import { authClerkAppearance } from '../appearance';

export default function RegisterPage() {
  return (
    <SignUp
      path="/register"
      routing="path"
      signInUrl="/login"
      appearance={authClerkAppearance}
    />
  );
}
